import burgeonConfig from '../../assets/config';

const prefixCls = `${burgeonConfig.prefixCls}`;

export default {
    data() {
        return {
            prefixCls: `${prefixCls}color-picker`,
            inputPrefixCls: `${prefixCls}input`,
            iconPrefixCls: `${prefixCls}icon`,
            transferPrefixCls: `${prefixCls}transfer`
        };
    }
};



// WEBPACK FOOTER //
// ./src/components/color-picker/prefixMixin.js